export enum Route {
    DocumentsList = "/documents/search",
}

export const documentFileRoute = (assetId: number): string => `/documents/${assetId}/file`;
